import React, { useContext, useEffect } from 'react'
import { useLazyQuery, NetworkStatus } from '@apollo/client'
import CardWidget from '../../../components/CardWidget'
import CardWidgetSkeleton from '../../../components/skeletons/CardWidgetSkeleton'
import { formatNumber } from '../../../utils/Helpers'
import { EventsFiltersContext } from '../../../context/EventsFiltersContext'
import { GET_QUANTITY_OFFERS_ERROR } from '../../../queries/events'

const QuantityQueue = (): JSX.Element => {
  const { filters } = useContext(EventsFiltersContext)
  const [getData, { loading, error, data, networkStatus }] = useLazyQuery(
    GET_QUANTITY_OFFERS_ERROR, {
      notifyOnNetworkStatusChange: true
    }
  )

  useEffect(() => {
    getData({
      variables: { filters }
    })
  }, [filters])

  if (networkStatus === NetworkStatus.refetch) return <CardWidgetSkeleton />
  if (loading || !data) return <CardWidgetSkeleton />
  if (error) return <p>Error :(</p>

  return (
    <CardWidget title="Ofertas com erro de validação" number={formatNumber(data.eventOfferIntegrationValidatorErrorAggs.aggregations.totals.value)}/>
  )
}

export default QuantityQueue
